import * as React from 'react';
import * as webHelpers from '../../../helpers/WebHelpers';
import { PageContainer, PortalPageType } from '../../components/container';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
//@ts-ignore
import {Box, Button, Flex, Grid, GridItem, Heading, Text, VStack} from '@chakra-ui/react';
import {LoadingPage} from "../../components/loading/index.";
import { IVerbalQuote } from '../../../interfaces/verbalquotes/IVerbalQuote';

import { DummyVerbalQuote } from '../../../DummyResponse/VerbalQuote';

import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'


export default function QuoteOverviewPage() {
    const [loading, setLoading] = React.useState<boolean>(false);

    const { quoteId } = useParams();
    
    const [quote, setQuote] = React.useState<IVerbalQuote | null>(null);

    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const sendDataToGTM = useGTMDispatch();


    const handleBookingClicked = () => {
        navigate("/quote/booking/" + quoteId);
    }

    const getQuote = async () => {
        return await webHelpers.getAsync<IVerbalQuote>(
            '/api/sales/quotes/verbal' + (quoteId == null ? "" : "?quote=" + quoteId),
            //undefined, DummyVerbalQuote //Comment out if running server
        );
    }


    const refresh = () => {
        getQuote().then(quote => {
            if (quote != null) {
                setQuote(quote);
            }

            setLoading(false);
            console.log(quote);
        });
    };

    // React.useEffect(() => {
    //     if (quoteId != undefined) {
    //         refresh();
    //     }
    // }, [ quoteId ]);

    React.useEffect(() => {
        if (quote == null && !loading) {
            setLoading(true);

            if (quoteId != null) {
                refresh();
            }
            else {
                navigate("/quote/signout");
            }
        }
    }, []);

    React.useEffect(() => {
        sendDataToGTM({quoteId: quote?.id, quoteValue: quote?.value_gross})
    }, [quote]);

    if (loading || quoteId == undefined || quote == undefined) {
        return <LoadingPage/>
    }


   return (
        <PageContainer pageTitle={'Quote'} type={PortalPageType.Quote}>
            <Flex direction="column" w='full'>
                <Flex mt={8}>
                    <Heading color="var(--Able-blue)" size='lg'>Online Booking</Heading>
                </Flex>

                <Flex mt={2}>
                    <Text size='xl'>Not the person paying for the work? Not going to be on site when the work is carried out? Give us a call and we can get you booked in.</Text>
                </Flex>

                <Flex mt={6}>
                    <Grid templateColumns={{ base: "repeat(1, 1fr)", md: "2fr 1fr" }} gap={4} w='full'>
                        <GridItem>
                            <Flex gap={2} w='full' border='1px' borderColor='gray.400' borderRadius="lg" direction="column" h='full'>
                                <Box borderBottom="2px" borderColor='gray.200' m={2} p={2}>
                                    <Text fontSize={22} fontWeight="semibold" color='var(--Able-blue)'>Your Quote</Text>
                                </Box>

                                <Flex p={4} pt={2}>
                                    {quote.original_quote.main.lines.map(line => 
                                        <Flex key={line.line_id} direction="column">
                                            <Text fontSize="xl">{line.quantity}x {line.name}</Text>
                                            {/* <Text>{line.product?.pricing_description}</Text> */}
                                        </Flex>    
                                    )}
                                </Flex>

                                <Flex p={4} pt={0}>
                                    <Button bg="var(--primary)" color="var(--primary-foreground)" onClick={handleBookingClicked}>
                                        Book Now
                                    </Button>
                                </Flex>
                            </Flex>
                        </GridItem>

                        <GridItem>
                            <Box borderWidth='1px' borderColor='gray.400' borderRadius='lg' h='full' p={2}>  
                                <Flex direction='column' w='full'>
                                    <Box borderBottom="2px" borderColor='gray.200' mb={2} p={2}>
                                        <Text fontSize={22} fontWeight="semibold" color='var(--Able-blue)'>Estimation</Text>
                                    </Box>

                                    <VStack fontSize='lg' pl={2} pr={2}>
                                        <Flex w='full' justify='space-between'>
                                            <Text>Labour:</Text>
                                            <Text>£{quote.value_labour_nett.toFixed(2)}</Text>
                                        </Flex>
                                        <Flex w='full' justify='space-between'>
                                            <Text>Materials:</Text>
                                            <Text>£{quote.value_materials_nett.toFixed(2)}</Text>
                                        </Flex>
                                        <Flex w='full' justify='space-between'>
                                            <Text>VAT:</Text>
                                            <Text>£{quote.value_vat.toFixed(2)}</Text>
                                        </Flex>
                                        <Flex w='full' justify='space-between'>
                                            <Text>Total:</Text>
                                            <Text><b>£{quote.value_gross.toFixed(2)}</b></Text>
                                        </Flex>
                                        <Text w='full' fontSize='sm' textAlign="center" mt={5} mb={5}>All prices are subject to site survey</Text>
                                    </VStack>
                                </Flex>
                                {/* {workReport ? <Pricing jobsheet={jobsheet} workReport={workReport}/> : (<></>)} */}
                            </Box>
                        </GridItem>
                    </Grid>
                </Flex>

                <Flex mt={6} gap={2} w='full' border="solid 1px lightgray" borderRadius="md" direction="column" p={2}>
                    <Box borderBottom="2px" borderColor='gray.200' mb={2} p={2}>
                        <Text fontSize={22} fontWeight='semibold' color='var(--Able-blue)'>Other services we've quoted for</Text>
                    </Box>
                    
                    <Flex direction="column">
                        {quote.original_quote.quotes.map((quote, index) => {
                            if (quote.is_primary == false) {
                                return (
                                    <Flex key={index} direction="column" p={2} w='full' mt={1}>
                                        {quote.lines.map(line => 
                                            <Flex key={line.line_id} direction="column">
                                                <Text>{line.quantity}x {line.name}</Text>
                                                <Text>{line.product?.pricing_description}</Text>
                                            </Flex>  
                                        )}
                                    </Flex>  
                                );
                            }

                            return <></>;
                        })}
                    </Flex>
                </Flex>
            </Flex>
        </PageContainer>
   );
}